import React from "react";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ErrorIcon from "@mui/icons-material/Error";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { BatchStatus } from "./useBatchSession";

// Each status has its own shape as well as its own colour, so it reads without
// colour too. Colours hold 3:1 against white and the slate tab background.
export const STATUS_META = {
  [BatchStatus.IDLE]: { Icon: RadioButtonUncheckedIcon, color: "#64748b", label: "Not edited" },
  [BatchStatus.SAVED]: { Icon: CheckCircleIcon, color: "#059669", label: "Saved" },
  [BatchStatus.APPLIED]: { Icon: RadioButtonCheckedIcon, color: "#2563eb", label: "Applied — not reviewed" },
  [BatchStatus.DUPLICATE]: { Icon: ContentCopyIcon, color: "#059669", label: "Duplicate — uses another platform's video" },
  [BatchStatus.UNSAVED]: { Icon: FiberManualRecordIcon, color: "#d97706", label: "Unsaved changes" },
  [BatchStatus.OUTDATED]: { Icon: FiberManualRecordIcon, color: "#d97706", label: "Copied edit changed at its source — copy again and save" },
  [BatchStatus.ERROR]: { Icon: ErrorIcon, color: "#dc2626", label: "Error" },
};

/** Decorative: the tab that shows it carries the status in its accessible name. */
export default function BatchStatusIcon({ status, size = 16 }) {
  const { Icon, color } = STATUS_META[status] || STATUS_META[BatchStatus.IDLE];
  return <Icon aria-hidden sx={{ fontSize: size, color, flexShrink: 0 }} />;
}
